


































import { AgentSalesDestination, Maybe, Query } from '@/types/generated/graphql'
import XCard from '@/components/atoms/Card/XCard.vue'
import AgentDestinationItem from '@/components/molecules/FfpAgent/Destination/AgentDestinationItem.vue'
import Vue from 'vue'
import GqlQuery from '@/components/atoms/Gql/GqlQuery.vue'
import XPagination from '@/components/atoms/Pagination/XPagination.vue'
import { DocumentNode } from 'graphql'
import QUERY_AGENT_DESTINATIONS from '@/graphql/partner/agentSalesDestinations.gql'

type Data = {
  query: DocumentNode
  pagination: {
    first: number
    page: number
    totalPage: number
    caption: {
      total: number
      from?: Maybe<number>
      to?: Maybe<number>
    }
  }
}

type Methods = {
  update: (data: Query) => AgentSalesDestination[]
  onSelectDestination: (destination: AgentSalesDestination) => void
}

type Computed = {
  variables: {
    partnerId: string
    storeId: string
    first: number
    page: number
  }
}

type Props = {
  partnerId: string
  storeId: string
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'AgentDestinationList',
  components: {
    AgentDestinationItem,
    XPagination,
    XCard,
    GqlQuery,
  },
  data() {
    return {
      query: QUERY_AGENT_DESTINATIONS,
      pagination: {
        first: 10,
        page: 1,
        totalPage: 0,
        caption: {
          total: 0,
          from: 0,
          to: 0,
        },
      },
    }
  },
  props: {
    // FIXME partnerIDは不要
    partnerId: {
      type: String,
      required: true,
    },
    storeId: {
      type: String,
      required: true,
    },
  },
  computed: {
    variables() {
      const { first, page } = this.pagination
      return { partnerId: this.partnerId, storeId: this.storeId, first, page }
    },
  },
  methods: {
    update({ agentSalesDestinations }) {
      const { data, paginatorInfo } = agentSalesDestinations
      this.pagination = {
        ...this.pagination,
        page: paginatorInfo.currentPage,
        totalPage: paginatorInfo.lastPage,
        caption: {
          total: paginatorInfo.total,
          from: paginatorInfo.firstItem,
          to: paginatorInfo.lastItem,
        },
      }
      return data
    },
    onSelectDestination(destination: AgentSalesDestination) {
      this.$emit('select:destination', destination)
    },
  },
})
